/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type {
  InterestRateDataResolver,
  InterestRateDataResolverInterface,
} from "../InterestRateDataResolver";

const _abi = [
  {
    inputs: [
      {
        internalType: "contract ISiloRepository",
        name: "_siloRepo",
        type: "address",
      },
      {
        internalType: "contract SiloLens",
        name: "_lens",
        type: "address",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    inputs: [],
    name: "EmptySilos",
    type: "error",
  },
  {
    inputs: [],
    name: "InvalidSiloLens",
    type: "error",
  },
  {
    inputs: [],
    name: "InvalidSiloRepository",
    type: "error",
  },
  {
    inputs: [
      {
        internalType: "contract ISilo",
        name: "_silo",
        type: "address",
      },
      {
        internalType: "address",
        name: "_asset",
        type: "address",
      },
    ],
    name: "getData",
    outputs: [
      {
        components: [
          {
            internalType: "address",
            name: "asset",
            type: "address",
          },
          {
            components: [
              {
                internalType: "int256",
                name: "uopt",
                type: "int256",
              },
              {
                internalType: "int256",
                name: "ucrit",
                type: "int256",
              },
              {
                internalType: "int256",
                name: "ulow",
                type: "int256",
              },
              {
                internalType: "int256",
                name: "ki",
                type: "int256",
              },
              {
                internalType: "int256",
                name: "kcrit",
                type: "int256",
              },
              {
                internalType: "int256",
                name: "klow",
                type: "int256",
              },
              {
                internalType: "int256",
                name: "klin",
                type: "int256",
              },
              {
                internalType: "int256",
                name: "beta",
                type: "int256",
              },
              {
                internalType: "int256",
                name: "ri",
                type: "int256",
              },
              {
                internalType: "int256",
                name: "Tcrit",
                type: "int256",
              },
            ],
            internalType: "struct IInterestRateModel.Config",
            name: "modelConfig",
            type: "tuple",
          },
          {
            internalType: "uint256",
            name: "currentInterestRate",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "siloUtilization",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "totalDepositsWithInterest",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "depositAPY",
            type: "uint256",
          },
        ],
        internalType: "struct InterestRateDataResolver.AssetData",
        name: "assetData",
        type: "tuple",
      },
      {
        internalType: "uint256",
        name: "timestamp",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "contract ISilo[]",
        name: "_silos",
        type: "address[]",
      },
    ],
    name: "getDataBatch",
    outputs: [
      {
        components: [
          {
            internalType: "contract ISilo",
            name: "silo",
            type: "address",
          },
          {
            components: [
              {
                internalType: "address",
                name: "asset",
                type: "address",
              },
              {
                components: [
                  {
                    internalType: "int256",
                    name: "uopt",
                    type: "int256",
                  },
                  {
                    internalType: "int256",
                    name: "ucrit",
                    type: "int256",
                  },
                  {
                    internalType: "int256",
                    name: "ulow",
                    type: "int256",
                  },
                  {
                    internalType: "int256",
                    name: "ki",
                    type: "int256",
                  },
                  {
                    internalType: "int256",
                    name: "kcrit",
                    type: "int256",
                  },
                  {
                    internalType: "int256",
                    name: "klow",
                    type: "int256",
                  },
                  {
                    internalType: "int256",
                    name: "klin",
                    type: "int256",
                  },
                  {
                    internalType: "int256",
                    name: "beta",
                    type: "int256",
                  },
                  {
                    internalType: "int256",
                    name: "ri",
                    type: "int256",
                  },
                  {
                    internalType: "int256",
                    name: "Tcrit",
                    type: "int256",
                  },
                ],
                internalType: "struct IInterestRateModel.Config",
                name: "modelConfig",
                type: "tuple",
              },
              {
                internalType: "uint256",
                name: "currentInterestRate",
                type: "uint256",
              },
              {
                internalType: "uint256",
                name: "siloUtilization",
                type: "uint256",
              },
              {
                internalType: "uint256",
                name: "totalDepositsWithInterest",
                type: "uint256",
              },
              {
                internalType: "uint256",
                name: "depositAPY",
                type: "uint256",
              },
            ],
            internalType: "struct InterestRateDataResolver.AssetData[]",
            name: "assetData",
            type: "tuple[]",
          },
        ],
        internalType: "struct InterestRateDataResolver.SiloAssetsData[]",
        name: "siloAssetsData",
        type: "tuple[]",
      },
      {
        internalType: "uint256",
        name: "timestamp",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "contract ISilo",
        name: "_silo",
        type: "address",
      },
      {
        internalType: "address",
        name: "_asset",
        type: "address",
      },
    ],
    name: "getModel",
    outputs: [
      {
        internalType: "contract IInterestRateModel",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "siloLens",
    outputs: [
      {
        internalType: "contract SiloLens",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "siloRepository",
    outputs: [
      {
        internalType: "contract ISiloRepository",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
];

const _bytecode =
  "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";

type InterestRateDataResolverConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: InterestRateDataResolverConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class InterestRateDataResolver__factory extends ContractFactory {
  constructor(...args: InterestRateDataResolverConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
    this.contractName = "InterestRateDataResolver";
  }

  deploy(
    _siloRepo: string,
    _lens: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<InterestRateDataResolver> {
    return super.deploy(
      _siloRepo,
      _lens,
      overrides || {}
    ) as Promise<InterestRateDataResolver>;
  }
  getDeployTransaction(
    _siloRepo: string,
    _lens: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(_siloRepo, _lens, overrides || {});
  }
  attach(address: string): InterestRateDataResolver {
    return super.attach(address) as InterestRateDataResolver;
  }
  connect(signer: Signer): InterestRateDataResolver__factory {
    return super.connect(signer) as InterestRateDataResolver__factory;
  }
  static readonly contractName: "InterestRateDataResolver";
  public readonly contractName: "InterestRateDataResolver";
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): InterestRateDataResolverInterface {
    return new utils.Interface(_abi) as InterestRateDataResolverInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): InterestRateDataResolver {
    return new Contract(
      address,
      _abi,
      signerOrProvider
    ) as InterestRateDataResolver;
  }
}
